import type { ReportTableConfigV1 } from '../models/tableConfig.types'

export const SUMMARY_CREATIVE_METRICS = [
  'cost',
  'clicks',
  'impressions',
  'cpm',
  'cpc',
  'ctr',
  'conversions',
  'conversions_value',
  'roas',
  'cost_per_conversion',
  'hook_rate',
  'hold_rate',
] as const

export const SUMMARY_CREATIVE_DIMENSIONS = [
  'campaign_name',
  'first_seen',
  'marketing_channel',
  'objective',
  'ad_name',
  'image_url',
  'thumbnail_url',
] as const

export const SUMMARY_ACQUISITION_CHART = {
  reportId: 6,
  partitionName: 'budget_allocation',
  dimensions: ['marketing_channel'],
  metrics: ['cost', 'mp_sessions', 'mmp_sessions'],
  sortField: 'cost',
  chartType: 'pie' as const,
}

/**
 * Product-authored table behavior. Rendering remains in Summary so changing the config source does
 * not change the panel's markup or visual language.
 */
export const SUMMARY_ACQUISITION_TABLE_CONFIG = {
  version: 1,
  defaultSort: { field: 'mp_sessions', order: -1 },
  allowColumnReorder: true,
  allowColumnResize: true,
  sortCycle: 'triState',
  initialSortDirection: 'desc',
  dropdowns: [
    {
      id: 'platform-filter',
      kind: 'filter',
      field: 'platform',
      labelKey: 'summary.acquisition.platform',
      mode: 'single',
      optionsSource: 'host',
    },
  ],
  additionalElements: [],
} as const satisfies ReportTableConfigV1

export const BUDGET_ALLOCATION_TABS = [
  'overview',
  'google_ads',
  'meta_ads',
  'criteo',
  'tiktok_ads',
  'linkedin',
  'snapchat_ads',
  'rtb_house',
  'dv360',
  'reklamstore',
  'akakce',
  'gelirortaklari',
  'yandex',
  'apple_search_ads',
  'app_samurai',
  'bing_ads',
  'yango',
  'hopi',
  'twitter_ads',
  'yandex_ads',
  'pinterest_ads',
  'reddit_ads',
  'cm360',
  'trivago',
  'metrics_sheet_campaign',
] as const
